import { useAuthInfo } from '@sweetauth/core'

import { useBillingOrganization } from '@/hooks/billing/useBillingOrganization'

export const useCanAccessPremium = () => {
  const { data: billingOrganization, isLoading: isLoadingBillingOrganization } =
    useBillingOrganization()
  const { isLoggedIn, loading: isLoadingAuthInfo } = useAuthInfo()
  const isLoading =
    isLoadingBillingOrganization ||
    isLoadingAuthInfo ||
    billingOrganization === undefined ||
    billingOrganization === null
  return {
    canAccessPremium:
      isLoggedIn &&
      billingOrganization !== undefined &&
      billingOrganization !== null &&
      (billingOrganization.tier === 'premium' ||
        billingOrganization.tier === 'enterprise'),
    isLoading,
  }
}
